import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MyprofilePhoto from '../../Assets/images/MyProfilePhoto.png';
import { FaFacebookSquare, FaLinkedinIn } from 'react-icons/fa';
import { MdMan, MdOutlineMan, MdLocationOn } from 'react-icons/md';
import { IoIosCall } from 'react-icons/io';
import { CgMail } from 'react-icons/cg';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
const MyProfile = ({ onClose }) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true); // For loading state
  const [error, setError] = useState(null); // For error handling
  const navigate = useNavigate();

  // Fetch the profile data when the component mounts
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/account/user-profile/`,
          // 'https://finwise-backend.vercel.app/account/user-profile/',
          // 'https://finwiseback.finwise.com.bd/account/user-profile/',
          // 'http://127.0.0.1:8000/account/user-profile/',
          {
            headers: {
              Cookie:
                'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
            },
            withCredentials: true, // Ensures cookies are sent with the request
          }
        );
        console.log(response.data);
        setProfileData(response.data); // Store profile data
        setLoading(false);
      } catch (error) {
        setError('Failed to fetch profile data');
        setLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  const handleProfileDetails = () => {
    navigate('/profileDetails');
    onClose();
  };

  // if (loading) {
  //   return <div>Loading...</div>; // Show a loading state while fetching
  // }

  if (error) {
    return <div>{error}</div>; // Show error if there's an error
  }

  return (
    <div className="p-0 bg-white rounded-lg shadow-2xl">
      <div className="absulate md:w-full w-80">
        <div className="bg-white rounded-lg  border border-headerBtn">
          {/* close button */}
          <button
            onClick={onClose}
            className="absolute top-2 right-4 text-headerBtn text-2xl font-bold hover:text-red-500"
          >
            &times;
          </button>

          {/* image, company description and edit button */}
          <div className="lg:p-6 p-2">
            {/* image section */}
            <div className="flex justify-center gap-10">
              <img
                // src={profileData?.company_logo || ''}
                // src={`http://127.0.0.1:8000${profileData?.company_logo}` || ''}
                src={
                  profileData?.company_logo
                    ? `http://127.0.0.1:8000${profileData.company_logo}`
                    : ''
                }
                alt="company_logo"
                className="w-24 h-24 mb-4 rounded-full border-4 border-gray-300"
              />
            </div>

            {/* company description */}
            <div className="border border-current p-2 mb-2 bg-AboutUsBg md:text-sm text-xs">
              <h2 className="text-lg font-bold">
                {profileData?.company_name || 'null'}
              </h2>
              <ul className="space-y-0">
                {/* <li className="flex items-center space-x-1">
                  <MdLocationOn className="text-gray-400" />
                  <span>
                    {profileData?.location || 'No location available'}
                  </span>
                </li> */}
                <li className="flex items-center space-x-1">
                  <IoIosCall className="text-gray-400" />
                  <span>{profileData?.phone}</span>
                </li>
                <li className="flex items-center space-x-2">
                  <CgMail className="text-gray-400" />
                  <span>{profileData?.email}</span>
                </li>
                <li className="flex items-center space-x-2">
                  <FaFacebookSquare className="text-gray-400" />
                  <span>
                    {profileData?.facebook_link || 'No Facebook link'}
                  </span>
                </li>
                <li className="flex items-center space-x-2">
                  <FaLinkedinIn className="text-gray-400" />
                  <span>
                    {profileData?.linkedin_link || 'No LinkedIn link'}
                  </span>
                </li>
              </ul>
            </div>

            {/* company md name */}
            <div className="border border-current p-2 bg-AboutUsBg md:text-sm text-xs">
              <ul className="space-y-0">
                <li className="flex items-center space-x-2">
                  <MdMan className="text-gray-400" />
                  <span className="flex gap-1 ">
                    <h2 className="font-bold md:block hidden ">
                      Company’s MD Name:
                    </h2>
                    <h2 className="font-bold md:hidden block ">
                      MD Name:
                    </h2>
                    {profileData?.company_md_name || 'not provided'}
                  </span>
                </li>
                <li className="flex items-center space-x-2">
                  <MdOutlineMan className="text-gray-400" />
                  <span className="flex gap-1">
                    <h2 className="font-bold md:block hidden ">
                      Company’s Chairman Name:
                    </h2>
                    <h2 className="font-bold md:hidden block ">
                      Chairman Name:
                    </h2>
                    {profileData?.company_chairman_name || 'not provided'}
                  </span>
                </li>
              </ul>
            </div>

            {/* profile edit button */}
            <div className="flex items-center justify-center lg:mt-6 mt-8">
              <button
                onClick={handleProfileDetails}
                type="button"
                className="bg-headerBtn text-white py-2 px-6 -mt-4 mx-auto rounded-xl hover:bg-btnHover"
              >
                Edit Profile
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
